/* eslint-disable */
import React from 'react'
import moment from 'moment'

import { ShowResultsInput, ShowResultsFormWrapper } from './styles'

const diaDaSemanaMap = [
    {
      value: 6,
      label: 'Dom',
    },
    {
      value: 0,
      label: 'Seg',
    },
    {
      value: 1,
      label: 'Ter',
    },
    {
      value: 2,
      label: 'Qua',
    },
    {
      value: 3,
      label: 'Qui',
    },
    {
      value: 4,
      label: 'Sex',
    },
    {
      value: 5,
      label: 'Sab',
    },
  ]

const getChoosenDays = (days) => {
    if (days === undefined || days.length === 7|| days.length === 0) return 'Todos os dias'
    const foundDays = diaDaSemanaMap.filter((dia => {
        const found = days.find(day => {
            return day === dia.value
        })
        return found !== undefined
    }))

    const stringOfDays = foundDays.map(day => day.label).toString()
    return stringOfDays
}

const getPeriodo = (periodo, rangeDates) => {
    if (rangeDates) {
      return `${moment(rangeDates.from).format('DD/MM/YYYY')} a ${moment(rangeDates.to).format('DD/MM/YYYY')}`
    }
    if (!periodo) return '90 dias'
    return `${periodo} dias`
}

const getTipoTransacao = (tipoTransacao, hasValePedagio) => {
    if (!tipoTransacao || tipoTransacao.length === 0) return 'Todos os tipos'
    if (tipoTransacao.length === 3) return 'Todos os tipos'
    if (hasValePedagio && tipoTransacao.length === 2) {
      return tipoTransacao.map(item => {
          return { PEDAGIO: 'Pedágio', ESTACIONAMENTO: 'Estacionamento', VALE_PEDAGIO: 'Vale-pedágio'}[item.tipo]
        })
    }
    return { PEDAGIO: 'Pedágio', ESTACIONAMENTO: 'Estacionamento', VALE_PEDAGIO: 'Vale-pedágio'}[tipoTransacao[0].tipo]
}

const getQuantidade = (quantidade) => {
    if(!quantidade) return '30 transações'
    return `${quantidade} transações`
}

function ShowResults({ selectedFilters, hasValePedagio, showQuantity = true}) {
    return (
      <ShowResultsFormWrapper>
        <ShowResultsInput placeholder={getTipoTransacao(selectedFilters.type, hasValePedagio)} disabled />
        <ShowResultsInput placeholder={getPeriodo(selectedFilters.periodo, selectedFilters.rangeDates)} disabled/>
        <ShowResultsInput placeholder={getChoosenDays(selectedFilters.diaDaSemana)} disabled/>
        {showQuantity && <ShowResultsInput placeholder={getQuantidade(selectedFilters.quantidade)} disabled/>}
      </ShowResultsFormWrapper>

  )
}

export default ShowResults



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatement/ShowResults/ShowResults.js